import { CancelTransactionArgs } from 'types/api/arguments/cancel-transaction-args'

import { api } from './api'

export const cancelTransaction = ({ id, reasonId, userExplanation }: CancelTransactionArgs) =>
  api.put(`/transactions/${id}/cancel`, {
    reason: {
      id: reasonId,
      user_explanation: userExplanation,
    },
  })
